import { render, staticRenderFns } from "./avisos.vue?vue&type=template&id=725c92ef&"
import script from "./avisos.vue?vue&type=script&lang=js&"
export * from "./avisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports